import React from "react";
import { HomeView } from "./HomeView";
export const HomeContainer = () => {
  return <HomeView />;
};
